import React, { useState } from 'react'
import { clearClipboard, pasteScenario, useClipboard } from 'stores/clipboard.store'

export const PasteScenario = props => {
  const { experienceId, history, siteUid } = props || {}
  const [loading, setLoading] = useState(false)

  const { type, date } = useClipboard()
  const isAvailable = type.value === 'scenario' && Date.now() - (date.value || 0) < 1000 * 60

  if (!isAvailable && !loading) return null

  return (
    <div style={{ display: 'flex', gap: 8 }}>
      <button
        className="btn btn-primary"
        style={{ flex: 1 }}
        disabled={loading}
        onClick={() => {
          setLoading(true)
          pasteScenario(experienceId, history, siteUid).finally(() => setLoading(false))
        }}
      >
        <i className={loading ? 'fa fa-spinner fa-spin' : 'fa fa-paste'} /> Coller le scénario
      </button>
      {!loading && (
        <button className="btn btn-default" onClick={() => clearClipboard()}>
          <i className="fa fa-times" />
        </button>
      )}
    </div>
  )
}
